@if(showSpinner){
<app-state-display state="loading"></app-state-display>
}@else{
<div class="card border-0 shadow-sm mb-4">
    <div class="card-body">

    <div class="nav-wizards-container">
        <nav class="nav nav-wizards-2 mb-2">
            <div class="nav-item col">
                <a class="nav-link" [ngClass]="{'completed': (tab > 1), 'active': (tab == 1)}" href="javascript:;"
                    (click)="tab = 1">
                    <div class="nav-text">Información Personal</div>
                </a>
            </div>

            <div class="nav-item col">
                <a class="nav-link" [ngClass]="{'completed': (tab > 2), 'active': (tab == 2), 'disabled': (tab < 2)}"
                    href="javascript:;" (click)="tab = 2">
                    <div class="nav-text">Datos Bancarios</div>
                </a>
            </div>

            <div class="nav-item col">
                <a class="nav-link" [ngClass]="{'active': (tab == 3), 'disabled': (tab < 3)}" href="javascript:;"
                    (click)="tab = 3">
                    <div class="nav-text">Datos de la Póliza</div>
                </a>
            </div>
        </nav>
    </div>

    @if(tab === 1){
        <app-information-personal (saveInsured)="saveInsured($event)" (cancel)="cancel.emit()" [insuredId]="transferForm.value.insuredId"></app-information-personal>
    }

    @if(tab == 2){
        <app-bank-account-form (save)="saveBankAccount($event)" (cancel)="cancel.emit()" (back)="tab = 1" [insuredId]="transferForm.value.insuredId"></app-bank-account-form>
    }

    @if(tab == 3){
        <app-policy-information (savePolicyInformation)="savePolicyInformation($event)" (cancel)="cancel.emit()" (back)="tab = 2"></app-policy-information>
    }

    </div>
</div>

}